import { encryptPayload, decryptResponse } from "../utils/apiEnvelope";
import { getNewAuthToken, isTokenExpired } from "../utils";
import { baseURL } from "../utils/url";
import { encrypt } from "../utils/encodingdecoding";
import { CLEAR_REDEMPTION_LIST, GET_REDEMPTION_LIST } from "./type";

export const getRedemption = (token, offset, limit) => async (dispatch) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + `getTransactionData?type=${encrypt("redeem")}&offset=${encrypt(String(offset))}&limit=${encrypt(String(limit))}`, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        decryptResponse(fetchResponse)
            .then((res) => {
                if (res) {
                    dispatch({
                        type: GET_REDEMPTION_LIST,
                        payload: res,
                    });
                    return res;
                } else {
                    return null;
                }
            })
            .catch(() => {
                return null;
            });
    } catch (error) {
        return error;
    }
};

export const clearRedemption = () => async (dispatch) => {
    dispatch({ type: CLEAR_REDEMPTION_LIST });
};
